import React from 'react';

import {EventReviewFeedback} from 'src/modules/ai';
import {MIXPANEL_DECORATED_FIELD_NAME} from 'src/modules/ai/constants';
import {HighlighterWrapper} from 'src/modules/event-review/highlighter/highlighter-wrapper';
import {HighlightFields} from 'src/modules/event-review/typedefs';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';
import {EventType} from 'src/openapi/models/EventType';
import {capitalize} from 'src/utils/capitalize';

import {Group, Item} from '@pb/kit-component-group';

type Props = {
    changeRequest: ChangeRequest,
    eventCodeInfo: EventDetailInfo | null,
    highlightsInfo: Record<HighlightFields, boolean> | null,
};

export const MixpanelDecorated = (props: Props) => {
    const {
        changeRequest,
        eventCodeInfo,
        highlightsInfo,
    } = props;

    return (
        <>
            {changeRequest.event.type === EventType.USER_EVENT ? (
                <Group>
                    <Group>
                        <strong>Mixpanel Decorated:</strong>
                        <EventReviewFeedback
                            changeRequestId={changeRequest.id}
                            fieldName={MIXPANEL_DECORATED_FIELD_NAME}
                        />
                    </Group>
                    <HighlighterWrapper
                        actualValue={eventCodeInfo ? capitalize(eventCodeInfo.decorated.toString()) : ''}
                        changeRequestValue={capitalize(changeRequest.event.decorated.toString())}
                        highlight={!!highlightsInfo?.[HighlightFields.decorated]}>
                        <Item>
                            {capitalize(changeRequest.event.decorated.toString())}
                        </Item>
                    </HighlighterWrapper>
                </Group>
            ) : null}
        </>
    );
};
